import { WebGLRenderer } from "three";
import { WebGLRenderTarget } from "three";
const CONTEXT_OPTIONS = {};
var WebGLContext = /* @__PURE__ */ ((WebGLContext2) => {
  WebGLContext2["WEBGL"] = "webgl";
  WebGLContext2["WEBGL2"] = "webgl2";
  WebGLContext2["EXPERIMENTAL_WEBGL"] = "experimental-webgl";
  WebGLContext2["EXPERIMENTAL_WEBGL2"] = "experimental-webgl2";
  return WebGLContext2;
})(WebGLContext || {});
let nextRendererId = 0;
const _RenderersController = class {
  constructor() {
    this._printDebug = false;
    this._require_webgl2 = false;
  }
  setPrintDebug(state = true) {
    this._printDebug = state;
  }
  printDebug() {
    return this._printDebug;
  }
  printDebugMessage(message) {
    if (!this._printDebug) {
      return;
    }
    console.warn("[Poly debug]", message);
  }
  setRequireWebGL2() {
    if (!this._require_webgl2) {
      this._require_webgl2 = true;
    }
  }
  webGL2Available() {
    if (this._webgl2_available === void 0) {
      this._webgl2_available = this._setWebGL2Available();
    }
    return this._webgl2_available;
  }
  _setWebGL2Available() {
    const canvas = document.createElement("canvas");
    return (window.WebGL2RenderingContext && canvas.getContext("webgl2" /* WEBGL2 */)) != null;
  }
  createWebGLRenderer(params) {
    const renderer = new WebGLRenderer(params);
    this.assignIdToRenderer(renderer);
    this.printDebugMessage([`create renderer:`, params]);
    return renderer;
  }
  assignIdToRenderer(renderer) {
    if (renderer._polygonId != null) {
      return;
    }
    const nextId = nextRendererId += 1;
    renderer._polygonId = nextId;
  }
  rendererId(renderer) {
    const id = renderer._polygonId;
    if (id == null) {
      console.error("renderer has no _polygonId");
      return;
    }
    return id;
  }
  getRenderingContext(canvas) {
    let gl = null;
    gl = this._getRenderingContextWebgl(canvas, true);
    if (!gl) {
      console.warn("failed to create webgl2 context");
    }
    if (!gl) {
      gl = this._getRenderingContextWebgl(canvas, false);
    }
    if (gl.contextId == null) {
      gl.contextId = _RenderersController._nextGlContextId++;
    }
    return gl;
  }
  _getRenderingContextWebgl(canvas, webgl2) {
    let context_name;
    if (this.webGL2Available()) {
      context_name = "webgl2" /* WEBGL2 */;
    } else {
      context_name = webgl2 ? "webgl2" /* WEBGL2 */ : "webgl" /* WEBGL */;
    }
    let gl = canvas.getContext(context_name, CONTEXT_OPTIONS);
    if (gl) {
      this.printDebugMessage(`create gl context: ${context_name}.`);
    } else {
      context_name = webgl2 ? "experimental-webgl2" /* EXPERIMENTAL_WEBGL2 */ : "experimental-webgl" /* EXPERIMENTAL_WEBGL */;
      this.printDebugMessage(`create gl context: ${context_name}.`);
      gl = canvas.getContext(context_name, CONTEXT_OPTIONS);
    }
    return gl;
  }
  renderTarget(width, height, parameters) {
    if (this.webGL2Available()) {
      const multiSampleRenderTarget = new WebGLRenderTarget(width, height, parameters);
      multiSampleRenderTarget.samples = 2;
      return multiSampleRenderTarget;
    } else {
      return new WebGLRenderTarget(width, height, parameters);
    }
  }
};
export let RenderersController = _RenderersController;
RenderersController._nextGlContextId = 0;
